import { setItem, getItem,removeItem } from '@/utils/storage-main.js'
const sendGuestMsg = (type, data) => {
  window.parent.postMessage({type: type, data: data}, '*')
}
const handleJump = () => {
  sendGuestMsg('success',{token:getItem('Authorization'),refresh_token: getItem('refresh_token'),expired_time:getItem('expired_time')})
}

const isGuest = () => {
  return getItem('business') === 'guest'
}

export {
  handleJump,
  isGuest
}